<section class="fee-change-add-form">
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>

  @if (form) {
    <form class="fee-change-add-form__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <app-information-block [text]="'FEE_CHANGE.IMPORT_XLSX_DESCRIPTION'"></app-information-block>
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['caption']"></astral-input>
          <astral-select [control]="form.controls['target']" [itemsSource]="targetSelection"></astral-select>
          <astral-select [control]="form.controls['conflictResolution']" [itemsSource]="strategySelection"></astral-select>
        </astral-layout-group>
        <app-information-block [text]="strategyDescription"></app-information-block>
        <app-single-file-upload
          class="fee-change-add-form__upload"
          (filesSelected)="filesSelected($event)"
          [fileValidator]="fileValidator"
        ></app-single-file-upload>
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['fileName']"></astral-input>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
